"use strict";
// _tracking.js
// 初回訪問時のクエリパラメータとランディング情報を Cookie に保存する。
//   - どのページ（index / a / b / contact）から入っても動作
//   - Cookie 名: sh_first_touch（90日間保持、初回のみ書き込み。測定項目は欠落時のみ補完）
//   - PHP 側（mail.php の postToGas）が $_COOKIE から直接読むため、
//     JS で hidden input に詰め替える必要は無いが、フォーム送信の保険として hidden も埋める。

(function () {
  var KEY = "sh_first_touch";
  var SESSION_ATTR_STORAGE_KEY = "google_session_attributes";

  function readFirstTouch() {
    var prefix = KEY + "=";
    var cookie = document.cookie.split("; ").find(function (item) {
      return item.indexOf(prefix) === 0;
    });
    if (!cookie) return null;
    try {
      return JSON.parse(decodeURIComponent(cookie.slice(prefix.length)));
    } catch (_e) {
      return null;
    }
  }

  function writeFirstTouch(payload) {
    var expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString();
    var secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie =
      KEY +
      "=" +
      encodeURIComponent(JSON.stringify(payload)) +
      "; expires=" +
      expires +
      "; path=/; SameSite=Lax" +
      secure;
  }

  function encodeSessionAttributes(params) {
    try {
      return btoa(unescape(encodeURIComponent(JSON.stringify(params))))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
    } catch (_e) {
      return "";
    }
  }

  function readStoredSessionAttributes() {
    try {
      return window.localStorage.getItem(SESSION_ATTR_STORAGE_KEY) || "";
    } catch (_e) {
      return "";
    }
  }

  function storeSessionAttributes(encoded) {
    if (!encoded) return;
    try {
      window.localStorage.setItem(SESSION_ATTR_STORAGE_KEY, encoded);
    } catch (_e) {
      // localStorage 不可時は Cookie / hidden にのみ残す。
    }
  }

  function hasAdsParams(urlParams) {
    var keys = Object.keys(urlParams || {});
    if (urlParams.gclid || urlParams.gbraid || urlParams.wbraid) {
      return true;
    }
    return keys.some(function (key) {
      return key.indexOf("gad_") === 0;
    });
  }

  function buildSessionAttributesFrom(urlParams, landingUrl, referrer, userAgent) {
    var sessionParams = {};
    Object.keys(urlParams || {}).forEach(function (key) {
      if (key.indexOf("gad_") === 0) {
        sessionParams[key] = urlParams[key];
      }
    });
    sessionParams.session_start_time_usec = String(Date.now() * 1000);
    sessionParams.landing_page_url = landingUrl || window.location.href;
    sessionParams.landing_page_referrer = referrer || "";
    sessionParams.landing_page_user_agent = userAgent || navigator.userAgent || "";
    return encodeSessionAttributes(sessionParams);
  }

  function captureSessionAttributes(urlParams, existingPayload) {
    if (hasAdsParams(urlParams)) {
      var encoded = buildSessionAttributesFrom(
        urlParams,
        window.location.href,
        document.referrer || "",
        navigator.userAgent || ""
      );
      storeSessionAttributes(encoded);
      return encoded;
    }

    var stored = readStoredSessionAttributes();
    if (stored) {
      return stored;
    }
    if (existingPayload && existingPayload.session_attributes) {
      return String(existingPayload.session_attributes);
    }
    var storedParams = existingPayload && existingPayload.params ? existingPayload.params : {};
    if (existingPayload && hasAdsParams(storedParams)) {
      return buildSessionAttributesFrom(
        storedParams,
        existingPayload.landing_url || window.location.href,
        existingPayload.referrer || "",
        existingPayload.user_agent || navigator.userAgent || ""
      );
    }
    return "";
  }

  function fillHiddenFields(name, value) {
    var safeValue = String(value || "");
    document.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
      input.value = safeValue;
    });
  }

  var params = {};
  try {
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      params[k] = v;
    });
  } catch (_e) {
    // URLSearchParams 非対応ブラウザでは params を空で記録
  }

  var payload = readFirstTouch();
  var sessionAttributes = captureSessionAttributes(params, payload);
  var userAgent = navigator.userAgent || "";
  var shouldWrite = false;

  if (!payload) {
    payload = {
      params: params,
      landing_url: window.location.href,
      landing_path: window.location.pathname,
      referrer: document.referrer || "",
      first_seen_at: new Date().toISOString(),
      user_agent: userAgent,
      session_attributes: sessionAttributes,
    };
    shouldWrite = true;
  } else {
    if (!payload.params || typeof payload.params !== "object") {
      payload.params = params;
      shouldWrite = true;
    }
    if (!payload.user_agent) {
      payload.user_agent = userAgent;
      shouldWrite = true;
    }
    if (sessionAttributes && payload.session_attributes !== sessionAttributes) {
      payload.session_attributes = sessionAttributes;
      shouldWrite = true;
    } else if (!payload.session_attributes && sessionAttributes) {
      payload.session_attributes = sessionAttributes;
      shouldWrite = true;
    }
  }

  if (shouldWrite) {
    writeFirstTouch(payload);
  }

  var firstTouchParams = payload && payload.params ? payload.params : {};
  var gclid = String(firstTouchParams.gclid || params.gclid || "").trim();
  var gbraid = String(firstTouchParams.gbraid || params.gbraid || "").trim();
  var wbraid = String(firstTouchParams.wbraid || params.wbraid || "").trim();
  var storedUserAgent = String(payload.user_agent || userAgent).trim();
  var storedSessionAttributes = String(
    payload.session_attributes || sessionAttributes || ""
  ).trim();

  fillHiddenFields("GCLID", gclid);
  fillHiddenFields("GBRAID", gbraid);
  fillHiddenFields("WBRAID", wbraid);
  fillHiddenFields("USER_AGENT", storedUserAgent);
  fillHiddenFields("SESSION_ATTRIBUTES", storedSessionAttributes);
})();
